// 눈누 뉴스레터(메일리) 구독/해지 — footer 폼, 계정 설정 토글이 함께 쓴다.
//
// <div data-controller="newsletter-subscription"
//      data-newsletter-subscription-url-value="/newsletter_subscription"
//      data-newsletter-subscription-messages-value='{"subscribed":"…", …}'>
//   <form data-action="submit->newsletter-subscription#subscribe">…</form>
// </div>
//
// 서버는 status 만 돌려주고(subscribed / unsubscribed / invalid_email / rate_limited), 문구는 화면 로케일에
// 맞춰 messages value 로 받아 둔다. 메일리 반영은 서버 잡이 맡으므로 여기서는 기다리지 않는다.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "honeypot", "submit", "message", "error", "whenSubscribed", "whenUnsubscribed"]
  static values = {
    url: String,
    messages: Object,
  }

  async subscribe(event) {
    event.preventDefault()

    const body = {}
    // 로그인 회원은 서버가 회원 이메일을 쓴다. 보여주기용 readonly 칸은 보내지 않는다.
    if (this.hasEmailTarget && !this.emailTarget.readOnly) body.email = this.emailTarget.value.trim()
    if (this.hasHoneypotTarget) body.website = this.honeypotTarget.value

    const status = await this.request("POST", body)
    if (status === "subscribed") {
      this.toggleState(true)
      this.showMessage(status, "success")
    } else {
      this.showMessage(status, "error")
    }
  }

  async unsubscribe(event) {
    event.preventDefault()

    const status = await this.request("DELETE")
    if (status === "unsubscribed") {
      this.toggleState(false)
      this.showMessage(status, "success")
    } else {
      this.showMessage(status, "error")
    }
  }

  async request(method, body = null) {
    this.setBusy(true)
    try {
      const response = await fetch(this.urlValue, {
        method,
        headers: this.headers(),
        credentials: "same-origin",
        body: body ? JSON.stringify(body) : null,
      })
      const data = await response.json().catch(() => ({}))
      return data.status || "error"
    } catch (_error) {
      return "error"
    } finally {
      this.setBusy(false)
    }
  }

  headers() {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    return {
      "Accept": "application/json",
      "Content-Type": "application/json",
      ...(token ? { "X-CSRF-Token": token } : {}),
    }
  }

  toggleState(subscribed) {
    this.whenSubscribedTargets.forEach((element) => element.classList.toggle("hidden", !subscribed))
    this.whenUnsubscribedTargets.forEach((element) => element.classList.toggle("hidden", subscribed))
  }

  // 성공 문구는 message 칸, 실패 문구는 error 칸(없으면 message 칸)에 띄운다.
  showMessage(status, tone) {
    const text = this.messagesValue[status] || this.messagesValue.error || ""
    const target = tone === "error" && this.hasErrorTarget ? this.errorTarget : (this.hasMessageTarget ? this.messageTarget : null)
    const other = target === this.messageTarget ? (this.hasErrorTarget ? this.errorTarget : null) : (this.hasMessageTarget ? this.messageTarget : null)

    if (other) other.classList.add("hidden")
    if (!target) return

    target.textContent = text
    target.dataset.tone = tone
    target.classList.remove("hidden")
  }

  setBusy(busy) {
    this.submitTargets.forEach((button) => {
      button.disabled = busy
      button.setAttribute("aria-busy", busy ? "true" : "false")
    })
  }
}
